import { message } from 'antd';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { useSubmitMassOfferingInbox } from '../../../api/actions/useSubmitMassOfferingInbox';
import {
  QUERY_PARAM_KEYS,
  QUERY_PARAM_VALUES,
} from '../../../constants/massOfferings/queryParamKeys';
import selectors from '../../../store/selectors';
import { MASS_OFFERINGS_PAYMENT_TYPES } from '../../AddMassOffering/constants';
import { InboxMassOfferingsForm } from '../InboxMassOfferingsForm/InboxMassOfferingsForm';
import { inboxMassOfferingsFormNames } from '../InboxMassOfferingsForm/inboxMassOfferingsFormNames';

export const formatValues = (values, isServiceFeeEnabled) => {
  return {
    donator_name: values[inboxMassOfferingsFormNames.fullName],
    donator_email: values[inboxMassOfferingsFormNames.email],
    donator_phone: values[inboxMassOfferingsFormNames.phone],
    offering_type_dictionary: values[inboxMassOfferingsFormNames.offeringType],
    offering_content: values[inboxMassOfferingsFormNames.offeringContent],
    offering_amount: values[inboxMassOfferingsFormNames.totalAmountToPay],
    ...(isServiceFeeEnabled && {
      service_fee_covered: values[inboxMassOfferingsFormNames.userCoversServiceFee],
    }),
    ...(values[inboxMassOfferingsFormNames.showAddress] && {
      offering_delivery_address: {
        country: values[inboxMassOfferingsFormNames.country],
        city: values[inboxMassOfferingsFormNames.city],
        zip_code: values[inboxMassOfferingsFormNames.zipCode],
        street: values[inboxMassOfferingsFormNames.street],
      },
    }),
  };
};

const navigateToFreeTransactionConfirmation = pathname => {
  const searchParams = new URLSearchParams({
    [QUERY_PARAM_KEYS.source]: QUERY_PARAM_VALUES.TRANSACTION,
    [QUERY_PARAM_KEYS.sourceType]: QUERY_PARAM_VALUES.SOURCE_INTERNAL,
    [QUERY_PARAM_KEYS.state]: QUERY_PARAM_VALUES.SUCCESS,
  });
  navigate(`${pathname}?${searchParams.toString()}`);
};

const navigateToPayLaterTransactionConfirmation = pathname => {
  const searchParams = new URLSearchParams({
    [QUERY_PARAM_KEYS.source]: QUERY_PARAM_VALUES.TRANSACTION,
    [QUERY_PARAM_KEYS.sourceType]: QUERY_PARAM_VALUES.SOURCE_INTERNAL,
    [QUERY_PARAM_KEYS.state]: QUERY_PARAM_VALUES.SUCCESS,
    [QUERY_PARAM_KEYS.paymentType]: QUERY_PARAM_VALUES.LATER,
  });
  navigate(`${pathname}?${searchParams.toString()}`);
};

export const AddMassOffering = ({ inboxDictionary }) => {
  const isServiceFeeEnabled = useSelector(selectors.selectIsServiceFeeEnabled);
  const { loading, mutate } = useSubmitMassOfferingInbox();

  const accountId = useSelector(selectors.getAccountId);

  const onSubmit = async values => {
    const { error, payload } = await mutate({
      accountId,
      formValues: formatValues(values, isServiceFeeEnabled),
    });

    if (error) {
      message.error('Wystąpił problem połączenia. Odśwież stronę i spróbuj ponownie', 8);
    } else {
      // eslint-disable-next-line no-restricted-globals
      location.href = payload.tpayLink;
    }

    if (error) {
      message.error('Wystąpił problem połączenia. Odśwież stronę i spróbuj ponownie', 8);
      return;
    }

    if (payload.tpayLink) {
      // eslint-disable-next-line no-restricted-globals
      location.href = payload.tpayLink;
    } else if (payload.paymentType === MASS_OFFERINGS_PAYMENT_TYPES.toBeChosen) {
      // eslint-disable-next-line no-restricted-globals
      navigateToPayLaterTransactionConfirmation(location.pathname);
    } else {
      // eslint-disable-next-line no-restricted-globals
      navigateToFreeTransactionConfirmation(location.pathname);
    }
  };

  return (
    <InboxMassOfferingsForm
      onSubmit={onSubmit}
      loading={loading}
      inboxDictionary={inboxDictionary}
    />
  );
};

AddMassOffering.propTypes = {
  inboxDictionary: PropTypes.array.isRequired,
};
